/* Mobile nav: sync header height + toggle is-away when header shrinks.
   Hide uses max-height + flex-end so bar and links move as one unit. */
(function () {
  var header = document.querySelector('.section-header');
  var section = document.querySelector('.fn-mobile-nav-bar-section');
  var bar = document.querySelector('[data-fn-mobile-nav-bar]');
  if (!header || !section || !bar) return;

  var raf = 0;
  var followUntil = 0;
  var openHeight = 0;
  var away = false;
  var hideTimer = null;
  var HIDE_DELAY_MS = 0;

  function syncHeaderHeight() {
    var height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }

  function measureOpenHeight() {
    if (away) return;

    section.style.maxHeight = 'none';
    openHeight = Math.ceil(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty(
      '--fn-mobile-nav-bar-max-height',
      openHeight + 'px'
    );
    section.style.maxHeight = '';
  }

  function scheduleSync() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = 0;
      syncHeaderHeight();
    });
  }

  function followShrink() {
    followUntil = performance.now() + 400;
    scheduleSync();

    function tick(now) {
      syncHeaderHeight();
      if (now < followUntil) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function setAway(nextAway) {
    if (nextAway === away) {
      if (!nextAway && hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      return;
    }

    if (nextAway) {
      measureOpenHeight();
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        hideTimer = null;
        away = true;
        section.classList.add('is-away');
      }, HIDE_DELAY_MS);
    } else {
      clearTimeout(hideTimer);
      hideTimer = null;
      away = false;
      section.classList.remove('is-away');
      measureOpenHeight();
    }
  }

  function onHeaderClassChange() {
    followShrink();
    setAway(header.classList.contains('scrolled-past-header'));
  }

  syncHeaderHeight();
  measureOpenHeight();
  setAway(header.classList.contains('scrolled-past-header'));

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'class') {
        onHeaderClassChange();
        return;
      }
    }
  }).observe(header, {
    attributes: true,
    attributeFilter: ['class'],
  });

  window.addEventListener(
    'resize',
    function () {
      scheduleSync();
      measureOpenHeight();
    },
    { passive: true }
  );

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(scheduleSync).observe(header);
  }
})();
